// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 16) return "static/js/8c4bf5e63c775a15fc4e.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"72c1a2e7c10b716f31fc","124":"385019040b318f9f8d95","125":"54b5d69254e22ad78a18"}[chunkId] + ".chunk.js";
};